// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-eb4e1762] .el-table__body-wrapper{height:auto !important}.base-table-container[data-v-eb4e1762]{width:100%}.base-table-container .pagination-container[data-v-eb4e1762]{margin-top:15px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}", ""]);
// Exports
module.exports = exports;
